/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { SOCIAL_PLATFORMS } from '@repo/config/social';
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const detailChallengeSchema = z.object({
  id: z.number(),
  slug: z.string(),
  phrase: z.string(),
  imageUrl: z.string().nullable().default(null),
});

const detailClipSchema = z.object({
  clipId: z.number(),
  collectionId: z.number().nullable(),
  durationMs: z.number(),
  subtitleText: z.string(),
  clipUrl: z.string().nullable().default(null),
  collectionName: z.string(),
});

const detailPublishedChannelSchema = z.object({
  channelId: z.number(),
  platform: z.enum(SOCIAL_PLATFORMS),
  permalink: z.string().nullable(),
  status: z.enum(['queued', 'publishing', 'published', 'failed']),
});

const detailVideoSchema = z.object({
  id: z.number(),
  version: z.number(),
  status: z.enum(['generating', 'ready', 'failed']),
  url: z.string().nullable(),
  posterUrl: z.string().nullable(),
  description: z.string().nullable(),
  fileSizeKb: z.number().nullable(),
  durationMs: z.number().nullable(),
  error: z.string().nullable(),
  createdAt: z.number(),
  publishedChannels: z.array(detailPublishedChannelSchema).default([]),
});

export type ISocialChallengeDetailChallenge = z.infer<typeof detailChallengeSchema>;
export type ISocialChallengeDetailClip = z.infer<typeof detailClipSchema>;
export type ISocialChallengeDetailPublishedChannel = z.infer<typeof detailPublishedChannelSchema>;
export type ISocialChallengeDetailVideo = z.infer<typeof detailVideoSchema>;

const detailDataSchema = z.object({
  challenge: detailChallengeSchema,
  clips: z.array(detailClipSchema),
  videos: z.array(detailVideoSchema),
});

export interface ISocialChallengeDetailData {
  challenge: ISocialChallengeDetailChallenge;
  clips: ISocialChallengeDetailClip[];
  videos: ISocialChallengeDetailVideo[];
}

export const getSocialChallengeDetailV1ResponseSchema = createApiResponseSchema(
  detailDataSchema,
) as z.ZodSchema<IAPI<ISocialChallengeDetailData>>;

export type IGetSocialChallengeDetailV1Response = IAPI<ISocialChallengeDetailData>;
